export default __webpack_public_path__ + "static/media/Placeholder_16_9.593e39e2.svg";